import { Logout } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import { useLogOut } from "../hooks/authentication/useLogOut";

const NoPremiumPage = () => {
    const onClickLogout = useLogOut();

    return (
        <div className="full-width full-height d-flex flex-column ai-center jc-center gap-1">
            <Typography variant="h3">albuMania</Typography>
            <Typography variant="h5">The Spotify account used to log in is not a Spotify Premium account</Typography>
            <Button
                variant="contained"
                color="error"
                onClick={onClickLogout}
                endIcon={<Logout />}
            >
                Log out
            </Button>
        </div>
    )
}

export default NoPremiumPage;